const flatpickr = require('flatpickr');
import { Polish } from 'flatpickr/dist/l10n/pl.js';

class FlatpickrDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.scope = {
            fpOpts: '&',
            fpOnSetup: '&'
        };
    }

    link(scope, element, attrs, ngModel) {
        let vp = new flatpickr(element[0], scope.fpOpts());

        if (scope.fpOnSetup) {
            scope.fpOnSetup({
                fpItem : vp
            });
        }

        element.on('click', function (e) {
            scope.$apply(function() {
                ngModel.$setViewValue(vp.selectedDateObj);
            });
        });
    }

    static directiveFactory() {
        'ngInject';
        return new FlatpickrDirective();
    }
}

export default FlatpickrDirective;